var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.diameter,"height":_vm.diameter}},[_c('path',{attrs:{"d":_vm._path,"fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }